import { render } from "./monitorDetail.vue?vue&type=template&id=80297448&scoped=true"
import script from "./monitorDetail.vue?vue&type=script&lang=js"
export * from "./monitorDetail.vue?vue&type=script&lang=js"

import "./monitorDetail.vue?vue&type=style&index=0&id=80297448&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80297448"]])

export default __exports__